module.exports = __webpack_public_path__ + "img/file-icon.af7d4e8a.svg";